<template>
  <v-layout column>
    <v-dialog width="350px" v-model="dialog">
      <v-card>
        <v-card-title class="headline mb-0">{{ `shop.dialog.${dialogkey}.title` | t }}</v-card-title>
        <v-card-text
          class="text-xs-left"
        >{{ $t(`shop.dialog.${dialogkey}.text`, { product_name }) }}</v-card-text>
        <v-card-actions v-if="dialogkey === 'downgrade'">
          <v-btn
            color="primary darken-1 white--text"
            flat="flat"
            @click.native="confirmProduct"
          >{{ `shop.dialog.${dialogkey}.confirm` | t }}</v-btn>
          <v-btn
            color="primary darken-1 white--text"
            flat="flat"
            @click.native="dialog = false"
          >{{ `shop.dialog.${dialogkey}.cancel` | t }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn
            color="primary darken-1 white--text"
            flat="flat"
            @click.native="dialog = false"
          >{{ `shop.dialog.${dialogkey}.confirm` | t }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex sm10>
      <v-card v-if="!getUserType" class="elevation-0 pb-3">
        <v-layout>
          <v-flex>
            <div primary-title class="primary--text">
              <h3 class="headline mb-3 ml-1 subtitol">{{ 'shop.step1' | t }}</h3>
            </div>
          </v-flex>
        </v-layout>
        <v-flex>
          <v-layout row wrap>
            <v-flex d-flex v-for="item in packs" :key="item.id" md4 sm12>
              <v-card v-bind:class="checkClass(item.id)" v-on:click.native="selectPlan(item.id)">
                <v-card-title>
                  <v-layout row wrap>
                    <v-flex md6 sm12>
                      <span class="headline">{{ item.name | capitalize }}</span>
                    </v-flex>
                    <v-flex md6 sm12 class="text-xs-right">
                      <span class="title" v-if="item.data[0].price === 0">Free</span>
                      <span v-else>
                        <span class="body-2">starts at</span>
                        <span class="title">{{ (item.data[0].price/100) }}&euro;</span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <v-card-text>
                  <v-flex>
                    <span class="title">{{ 'shop.characteristics' | t }}</span>
                    <v-divider></v-divider>
                  </v-flex>
                  <v-flex>
                    <div class="subheading mt-2">{{ item.description[$i18n.locale][1] }}</div>
                    <div class="subheading mt-3">{{ item.description[$i18n.locale][2] }}</div>
                    <div class="subheading mt-3">{{ item.description[$i18n.locale][3] }}</div>
                    <div class="subheading mt-3">{{ item.description[$i18n.locale][4] }}</div>
                    <div class="subheading mt-3">{{ item.description[$i18n.locale][5] }}</div>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout>
          <v-flex>
            <div primary-title class="primary--text">
              <h3 class="headline mb-0 ml-3 mt-5">{{ 'shop.step2' | t }}</h3>
            </div>
          </v-flex>
        </v-layout>
        <v-card v-if="packs.length > 0" class="elevation-0 ml-3 mr-3 mb-3">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md6 lg7 class="mt-2 ml-4">
                <v-slider
                  v-if="selected === 2 | selected === 3"
                  v-model="position"
                  :tick-labels="ticksLabels"
                  :max="5"
                  step="1"
                  ticks="always"
                  tick-size="2"
                ></v-slider>
              </v-flex>
              <v-flex xs5 sm5 md1 lg1 offset-md1 class="mt-2 mr-4">
                <div style="font-size: 15px;">
                  <b>{{ 'shop.req_month' | t }}</b>
                </div>
                <div
                  v-if="selected === 1"
                  class="text-xs-left mt-2 subheading"
                >{{ packs[selected-1].data[0].requests | formatnumber }}</div>
                <div
                  v-else
                  class="text-xs-left mt-2 subheading"
                >{{ packs[selected-1].data[position].requests | formatnumber }}</div>
              </v-flex>
              <v-flex xs sm6 md1 lg1 class="mt-2">
                <div class="text-xs-center" style="font-size: 15px;">
                  <b>{{ 'shop.price_month' | t }}</b>
                </div>
                <div
                  v-if="selected === 1"
                  class="text-xs-center mt-2 subheading"
                >{{ packs[selected-1].data[0].price | currency }}&euro;</div>
                <div
                  v-else
                  class="text-xs-center mt-2 subheading"
                >{{ packs[selected-1].data[position].price | currency }}&euro;</div>
              </v-flex>
              <v-flex xs12 sm12 md1 lg1 class="mt-3 mr-2">
                <v-btn dark color="primary" class="mt-3" @click="addShop">{{ 'shop.buy' | t }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-card>
      <v-card v-else class="elevation-0 pb-3">
        <div primary-title class="primary--text">
          <h3 class="headline mb-5 mt-1 ml-2">{{ 'shop.title_adhoc' | t }}</h3>
        </div>
        <v-flex md8 offset-md2>
          <v-card class="elevation-2 actual medium" align-content-center>
            <v-layout row>
              <v-flex xs12 sm12 md6 lg6 class="pa-3">
                <v-card-text>
                  <p>
                    <b>Product:</b>
                    {{getConsumer('digital').product_name}}
                  </p>
                  <p>
                    <b>Request limit:</b>
                    {{getConsumer('digital').counter_limit}}
                  </p>
                  <p>
                    <b>Price:</b>
                    {{getConsumer('digital').price}}
                  </p>
                  <p>
                    <b>TS max:</b>
                    {{getConsumer('digital').product_ts_max}}
                  </p>
                  <p>
                    <b>TS min:</b>
                    {{getConsumer('digital').product_tsi_delay}}
                  </p>
                  <p>
                    <b>Redirection:</b>
                    {{getConsumer('digital').product_redirect}}
                  </p>
                </v-card-text>
              </v-flex>
              <v-flex xs12 sm12 md6 lg6 class="pa-3">
                <v-card-text>
                  <b>Data Model:</b>
                  <li v-for="mod in datamodel" v-bind:key="mod">{{mod}}</li>
                </v-card-text>
              </v-flex>
            </v-layout>
            <v-card-actions v-if="getUserType === 1">
              <v-flex text-md-right>
                <v-btn dark color="primary" class="mt-3" @click="adHoc">{{ 'shop.buy' | t }}</v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "getServer",
      "getConsumer",
      "getUserId",
      "getTokenHeader",
      "getUserType"
    ])
  },
  data() {
    return {
      formload: true,
      value: 0,
      position: 0,
      ticksLabels: [],
      selected: 1,
      mypack: 3,
      packs: [],
      lang: "en",
      dialog: false,
      dialogkey: "same",
      product_name: "Developer",
      datamodel: [""]
    };
  },
  created() {
    if (this.getUserType !== 0) {
      const product_data = this.getConsumer("digital").product_data_model;
      const data = JSON.parse(product_data);
      this.datamodel = data;
    } else {
      this.mypack = this.getConsumer("digital").product_set;
      this.selected = this.mypack;
      this.getProducts();
    }

    this.formload = false;
  },

  methods: {
    ...mapActions(["setMyConsumers", "rmKey", "setProduct"]),
    getProducts() {
      this.$http
        .get(`${this.getServer}/products/packs`, this.getTokenHeader)
        .then(data => {
          if (data.data && Array.isArray(data.data)) {
            this.packs = data.data.map(pk => {
              pk.description = JSON.parse(pk.description);
              return pk;
            });

            const element = this.packs[this.selected - 1].data.find(
              x => x.id === this.getConsumer("digital").product
            );
            this.ticksLabels = this.packs[1].data.map(x => {
              return this.$formatnumber(x.requests);
            });

            this.position = this.packs[this.selected - 1].data.indexOf(element);
          }
        });
    },
    selectPlan(plan) {
      this.selected = plan;
    },
    checkClass(plan) {
      var a =
        this.mypack === plan ? "actual elevation-2 pa-4" : "elevation-2 pa-4";
      a += this.selected === plan ? " seleccionat" : "";
      return a;
    },
    addShop() {
      this.product_name = this.packs[this.selected - 1].name;

      if (this.getConsumer("digital").product_set === this.selected) {
        const virtualpos = this.selected === 1 ? 0 : this.position;
        const selectedproduct = this.packs[this.selected - 1].data[virtualpos]
          .id;

        if (this.getConsumer("digital").product === selectedproduct) {
          this.dialogkey = "same";
          this.dialog = true;
        } else if (this.getConsumer("digital").product < selectedproduct) {
          this.confirmProduct();
        } else if (this.getConsumer("digital").product > selectedproduct) {
          this.dialogkey = "downgrade";
          this.dialog = true;
        }
      } else if (this.getConsumer("digital").product_set < this.selected) {
        this.confirmProduct();
      } else if (this.getConsumer("digital").product_set > this.selected) {
        this.dialogkey = "downgrade";
        this.dialog = true;
      }
    },
    confirmProduct() {
      this.setProduct(this.packs[this.selected - 1].data[this.position].id);

      if (this.getConsumer("digital").product_set === this.selected) {
        const virtualpos = this.selected === 1 ? 1 : this.position;
        const selectedproduct = this.packs[this.selected - 1].data[virtualpos]
          .id;
        this.setProduct(selectedproduct);

        if (this.getConsumer("digital").product < selectedproduct) {
          this.$router.push({ path: "/shop/validate" });
        } else if (this.getConsumer("digital").product > selectedproduct) {
          this.$router.push({ path: "/shop/downgrade" });
        }
      } else if (this.getConsumer("digital").product_set < this.selected) {
        this.$router.push({ path: "/shop/validate" });
      } else if (this.getConsumer("digital").product_set > this.selected) {
        this.$router.push({ path: "/shop/downgrade" });
      }
    },
    adHoc() {
      this.setProduct(0);
      this.$router.push({ path: "/shop/validate" });
    }
  }
};
</script>

<style scoped>
.seleccionat {
  border: 2px solid #27408b;
}

.actual {
  background-color: #dee0e7 !important;
}
</style>
